import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=63798b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63798b2b"]])

export default __exports__